<template>
  <PlanDetail
      :plan="plan"
      :categories="categories"
      @delete="openDelete"
      @update="openEdit"
      @addItem="openCreateItem"
      @updateItem="openEditItem"
      @dragItems="onDragItem"
  />

  <BaseModal
      v-if="isEditOpen"
      title="Изменить план"
      @close="closeEdit"
  >
    <PlanForm
        :initial="initial"
        :errorMessage="messagePlanError"
        @submit="onUpdate"
        @cancel="closeEdit"
    />
  </BaseModal>

  <!----PlanItem Forms -->
  <BaseModal
      v-if="isCreateItemOpen"
      title="Добавить категорию"
      @close="closeCreateItem"
  >
    <PlanItemForm
        :initial="initialItem"
        :categories="categories"
        :errorMessage="messagePlanItemsError"
        @submit="onAddItem"
        @cancel="closeCreateItem"
    />
  </BaseModal>

  <BaseModal
      v-if="isEditItemOpen"
      title="Изменить категорию"
      @close="closeEditItem"
  >
    <PlanItemForm
        :initial="initialItem"
        :errorMessage="messagePlanItemsError"
        @submit="onUpdateItem"
        @cancel="closeEditItem"
        @delete="openDeleteItem"
    />
  </BaseModal>

  <DeleteModal
      title="Подтвердите удаление"
      :isOpen="isOpenDelete"
      @accept="onDelete"
      @close="closeDelete"
  />

  <DeleteModal
      title="Подтвердите удаление"
      :isOpen="isOpenDeleteItem"
      @accept="onDeleteItem"
      @close="closeDeleteItem"
  />
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from 'vue';
import { useRouter } from 'vue-router';
import {usePlan} from "@/features/plans/composables/usePlan";
import PlanDetail from "@/features/plans/components/PlanDetail.vue";
import {usePlanItem} from "@/features/plans/composables/usePlanItem";
import BaseModal from "@/components/ui/components/BaseModal.vue";
import PlanForm from "@/features/plans/components/PlanForm.vue";
import PlanItemForm from "@/features/plans/components/PlanItemForm.vue";
import {listCategories} from "@/api/categories";
import DeleteModal from "@/components/ui/components/DeleteModal.vue";

const router = useRouter();
const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
});

const {
  plans,
  plan,
  loadingPlan,

  isSuccessPlan,
  messagePlanSuccess,
  messagePlanError,

  load,
  detailPlan,
  addPlan,
  updatePlan,
  deletePlan
} = usePlan();

const {
  planItems,
  loadingPlanItems,
  isSuccessPlanItems,
  messagePlanItemsError,
  messagePlanItemsSuccess,

  loadPlanItems,
  addPlanItem,
  updatePlanItem,
  sortPlanItems,
  deletePlanItem
} = usePlanItem(props.id);

const page = 1;
const size = 1000;

const isCreateOpen = ref(false);
const isEditOpen = ref(false);
const initial = reactive({});

const isCreateItemOpen = ref(false);
const isEditItemOpen = ref(false);
const initialItem = reactive({});

const categories = ref([]);

onMounted(async () => {
  await Promise.all([detailPlan(props.id), loadPlanItems()]);
  const data = await listCategories(1, 1000);
  categories.value = data.content;
});

function openEdit(payload) {
  initial.id = payload.id;
  initial.name = payload.name;
  initial.amount = payload.amount;
  initial.scopeType = payload.scopeType;
  initial.dateFrom = payload.dateFrom;
  initial.dateTo = payload.dateTo;
  isEditOpen.value = true;
}
function closeEdit() {
  isEditOpen.value = false;
  for (var field in initial) {
    initial[field] = '';
  }
  messagePlanError.value = "";
}

async function onUpdate(payload) {
  await updatePlan(payload.id, {
    name: payload.name,
    amount: payload.amount,
    scopeType: payload.scopeType,
    dateFrom: payload.dateFrom,
    dateTo: payload.dateTo,
  });
  if (isSuccessPlan.value) {
    closeEdit();
    await detailPlan(props.id);
  }
}

async function onAddItem(payload) {
  await addPlanItem({
    name: payload.name,
    amount: payload.amount,
    categoryId: payload.categoryId,
  });
  if (isSuccessPlanItems.value) {
    closeCreateItem();
    await detailPlan(props.id);
  }
}

function openCreateItem() {
  isCreateItemOpen.value = true;
}
function closeCreateItem() {
  isCreateItemOpen.value = false;
  messagePlanItemsError.value = "";
}

function openEditItem(payload) {
  initialItem.id = payload.id;
  initialItem.amount = payload.amount;
  isEditItemOpen.value = true;
}
function closeEditItem() {
  isEditItemOpen.value = false;
  for (var field in initialItem) {
    initialItem[field] = '';
  }
  messagePlanItemsError.value = "";
}

async function onUpdateItem(payload) {
  await updatePlanItem(payload.id, {
    sort: payload.sort,
    amount: payload.amount,
  });
  if (isSuccessPlanItems.value) {
    closeEditItem();
    await detailPlan(props.id);
  }
}

const onDragItem = async (itemCards) => {
  const itemsSort = itemCards.map((plan, index) => ({
    id: plan.id,
    sort: index + 1
  }));

  await sortPlanItems({items: itemsSort});
  await detailPlan(props.id);
}

const isOpenDelete = ref(false);
const deleteObj = ref(null);
function openDelete(payload) {
  isOpenDelete.value = true;
  deleteObj.value = payload
}

function closeDelete() {
  isOpenDelete.value = false;
}

async function onDelete() {
  await deletePlan(deleteObj.value.id);
  deleteObj.value = null;
  isOpenDelete.value = false;
  await router.push({ name: 'PlansList' })
}

const isOpenDeleteItem = ref(false);
const deleteItemObj = ref(null);
function openDeleteItem(payload) {
  isOpenDeleteItem.value = true;
  deleteItemObj.value = payload
}

function closeDeleteItem() {
  isOpenDeleteItem.value = false;
}

async function onDeleteItem() {
  await deletePlanItem(deleteItemObj.value.id);
  deleteItemObj.value = null;
  isOpenDeleteItem.value = false;
  closeEditItem();
  await detailPlan(props.id);
}
</script>
